import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-banner-v3',
  templateUrl: './BannerV3.component.html',
  styleUrls: ['./BannerV3.component.scss']
})
export class BannerV3Component implements OnInit {

  @Input() pageTitle: any;
  @Input() bgImage: any;

  constructor() {
  }

  ngOnInit() {
  }

}
